// extracted by mini-css-extract-plugin
export var container = "_5j-0";
export var error = "_5j-9";
export var label = "_5j-5";
export var light = "_5j-6";
export var md = "_5j-3";
export var sm = "_5j-2";
export var thin = "_5j-8";
export var thinBold = "_5j-7";
export var vertical = "_5j-4";
export var xs = "_5j-1";